import React from 'react'
import CreateBillPay from 'src/app/CreateBillPay/CreateBillPay'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { createBillPayRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CreateBillPayAppRoute: AppRoute = {
  id: AppLocation.CreateBillPay,
  routeProps: createBillPayRouteProps,
  component: <CreateBillPay />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CreateBillPayAppRoute
